import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { DynamicPriceIcon } from '../../shared/icons/DynamicPriceIcon'
import { StaticPriceIcon } from '../../shared/icons/SaticPriceIcon'
import { TariffCategory } from '../../shared/models/types'

const useStyles = makeStyles()(theme => ({
  title: {
    marginLeft: theme.spacing(1.5),
  },
}))

interface Props {
  tariffCategory: TariffCategory
}

/**
 * Takes tariff category("DYNAMIC" or "STATIC") as a prop and displays a corresponding icon
 * together with the translated title "(Dynamic)".
 */
export const TariffCategoryCell: React.FC<Props> = ({ tariffCategory }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  return (
    <Stack direction="row">
      <Box alignSelf="center">{tariffCategory === TariffCategory.dynamicTariff ? <DynamicPriceIcon /> : <StaticPriceIcon />}</Box>

      <Box alignSelf="center">
        <Typography variant="body2" className={classes.title} alignSelf="center">
          {tariffCategory === TariffCategory.dynamicTariff
            ? t('emobility.chargingSession.tariff-category-dynamic-title')
            : t('emobility.chargingSession.tariff-category-static-title')}
        </Typography>
      </Box>
    </Stack>
  )
}
